module.exports = __webpack_public_path__ + "img/Slider_Datacenter.0373378b.jpg";